import React from 'react'
import cl from 'classnames'
import { Props } from './types'
import { presets } from './presets'

const PageTopContainer = ({ children, preset = 'primary', className }: Props) => {
  return (
    <div className={cl(presets[preset], className)}>
      {children}
    </div>
  )
}

export { PageTopContainer }
